import { Flex } from '@chakra-ui/react';
import { DateTime } from 'luxon';
import React from 'react';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { ComponentGridRenderer } from '~/core/routes/dev/ComponentGridRenderer';
import { PageTemplate } from '~/core/routes/dev/PageTemplate';
import { Timestamp } from '~/packages/common-frontend/components/Timestamp';

// Constants
const COMPONENT_NAME = './common-frontend/Timestamp';

// Fragments
const RouteBase = () => (
  <PageTemplate title={COMPONENT_NAME}>
    <ComponentGridRenderer
      primaries={['timeago', 'datetime'] as const}
      primaryPropName="variant"
      secondaries={[null]}
      tertiaries={[null]}
      width="25rem"
    >
      {({ primary: variant }) => {
        const timestamp = DateTime.now().minus({ minutes: 155 });
        return (
          <Flex direction="column" gap="0.5rem" flexGrow={1}>
            <Flex justifyContent="space-between" gap="0.5rem" flexGrow={1}>
              <span>Without dot: </span>
              <Timestamp variant={variant} timestamp={timestamp} />
            </Flex>
            <Flex justifyContent="space-between" gap="0.5rem" flexGrow={1}>
              <span>With dot: </span>
              <Timestamp variant={variant} timestamp={timestamp} showDot />
            </Flex>
            <Flex justifyContent="space-between" gap="0.5rem" flexGrow={1}>
              <span>Customized date formats: </span>
              <Timestamp
                variant={variant}
                timestamp={timestamp}
                shortLocaleFormat={{
                  year: '2-digit',
                  era: 'short',
                  timeZoneName: 'shortGeneric',
                }}
                tooltipLocaleFormat={{
                  year: 'numeric',
                  era: 'long',
                  timeZoneName: 'longGeneric',
                }}
              />
            </Flex>
          </Flex>
        );
      }}
    </ComponentGridRenderer>
  </PageTemplate>
);

// Exports
export const Route = () => (
  <RouteErrorBoundary
    resetAfterCatch={false}
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <div>Uh oh</div>;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
